var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu-headline",style:({ color: _vm.color })},[_vm._v(" "+_vm._s(_vm.content)+" "),_c('ArrowIcon',{staticClass:"arrow",class:{ 'arrow--down': _vm.arrowDown },attrs:{"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }